export default "__VITE_ASSET__792cb3a6__"